import React, { useCallback, useEffect, useRef } from "react";
import styled from "styled-components";

import { cardStyle } from "../../../AuthenticatedApp/components/invoicing/common/styles";
import { ReactComponent as FaceID } from "../../../../assets/img/faceid.svg";

const PassKeyFailedModal = ({ onClose }) => {
    const wrapperRef = useRef();

    const handleClickOutside = useCallback(
        (event) => {
            if (
                wrapperRef &&
                !wrapperRef.current.contains(event.target) &&
                !document.body.classList.contains("call-active")
            ) {
                onClose();
            }
        },
        [onClose],
    );

    useEffect(() => {
        document.body.classList.add("backdrop-init");
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.body.classList.remove("backdrop-init");
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside]);

    return (
        <div className="modal">
            <div className="fadeIn animated modal-backdrop">
                <Content className="kudaFadeInUp animated" ref={wrapperRef}>
                    <h3 className="text-center text-xbold text-subheading-md color-black bottom-spacer--md">
                        Verify With Passkey
                    </h3>

                    <div className="flex justify-center align-center mr-auto ml-auto bottom-spacer--md">
                        <FaceID />
                    </div>

                    <p className="color-primary text-center mr-auto ml-auto text-smd">
                        We couldn't complete your verification.
                    </p>

                    <p className="color-primary text-center mr-auto ml-auto text-smd">
                        Please, try again or contact us to get support.
                    </p>

                    <div className="modal-buttons flex justify-between">
                        <button
                            onClick={() => {
                                window.Intercom("showNewMessage");
                                onClose();
                            }}
                            className="modal-buttons-left color-primary text-bold"
                        >
                            Contact Us
                        </button>
                        <button
                            onClick={onClose}
                            className="modal-buttons-right color-white text-bold"
                        >
                            <span>Try Again</span>
                        </button>
                    </div>
                </Content>
            </div>
        </div>
    );
};

const Content = styled.div`
    ${cardStyle};
    width: 415px;
    max-width: 95%;
    max-height: 98%;
    padding: 40px;

    .modal {
        &-buttons {
            margin-top: 40px;
            width: 100%;
            column-gap: 20px;

            button {
                height: 48px;
                border-radius: 10px;
                cursor: pointer;
                width: 100%;
            }

            &-left {
                border: 1px solid var(--primaryColor);
                background-color: var(--whiteColor);
            }

            &-right {
                background: var(--primaryColor);
            }
        }
    }
`;

export default PassKeyFailedModal;
